import React, { Fragment } from "react";
import PopupMenu from "../../PopupMenu";
import { FaEllipsisH } from "react-icons/fa";

const ActionsPopup = (props) => {
  const { schema, id } = props;

  const contentStyle = {
    boxShadow: "inset 0px 4px 0px 0px #AEB0B5, 0 2px 6px 0 rgba(0,0,0,0.5)",
    padding: "0",
    paddingTop: "4px",
    border: "none",
  };

  const arrowStyle = {
    width: "0",
    height: "0",
    borderStyle: "solid",
    borderWidth: "0 0 13px 13px",
    outline: "none",
    borderColor: "transparent transparent #AEB0B5 transparent",
    background: "transparent",
    boxShadow: "none",
  };

  const renderMenuItem = (menuItem, id) => {
    const { color, label, action, component: Component } = menuItem;

    const menuItemStyle = {
      padding: "14px 10px 14px 20px",
      color: `${color}`,
      cursor: "pointer",
    };

    if (Component) {
      return <Component menuItemStyle={menuItemStyle} id={id} />;
    } else {
      return (
        <div>
          <div
            style={menuItemStyle}
            className="menu-item dropdown-label-View"
            onClick={() => action(id) || undefined}
            onKeyUp={(e) => {
              if (e.key === " ") {
                return action(id) || undefined;
              }
            }}
          >
            <span>{label}</span>
          </div>
        </div>
      );
    }
  };

  const renderAllMenuItems = schema.map((menuItem, index, arr) => (
    <Fragment key={index}>
      {renderMenuItem(menuItem, id)}
      {arr.length - 1 !== index && <hr />}
    </Fragment>
  ));

  return (
    <PopupMenu
      contentStyle={contentStyle}
      arrowStyle={arrowStyle}
      trigger={
        <FaEllipsisH
          className="EllipsisIcon"
          size={20}
          style={{ cursor: "pointer" }}
        />
      }
      position="bottom right"
      closeOnDocumentClick
    >
      <div>{renderAllMenuItems}</div>
    </PopupMenu>
  );
};

export default ActionsPopup;
